module.exports = __webpack_public_path__ + "static/media/kefa-ii-pro-bold.8bf5e43b.woff";